/*jshint esversion: 6*/
import {
    Common__$,
    Common__domHasClass,
    Common__domShow,
    Common__domHide,
    Common__domAddClass,
    Common__domOn,
    Common__domClosest,
    Common__domRemoveClass,
    Common__debounce,
    Common__throttle,
    Common__domTrigger,
    Common__arrayRemove,
    Common__$$,
} from './mi/common';

import {
    Fragment__init,
    Fragment__insertReadMore,
    Fragment__insertTag,
    Fragment__insertBottomTag,
    Fragment__insertXiangaknBtn,
} from './mi/fragment';

import {
    Utils__isMiuiBrowser,
    Utils__checkInitTime,
    Utils__getQueryString,
    Utils__parseQuery,
    Utils__getBrowserCategory,
    Utils__getShareChannel,
    Utils__scrollToWithLinear,
    Utils__postMessage,
    Utils__isDetailFragmentShow,
    Utils__notifyClientArticleNotFound,
} from './utils';

import { tpl__feedbackContent } from './mi/tpl';
import stats__send from './stats';
import { browserShareAppId, browserShareToken } from './conf';

var _miDetail__disStartTime = 0, //用来保证用户看到弹窗和遮罩层之后的点击是有效的
    _miDetail__disReasons = [],
    _miDetail__feedBack = {},
    _miDetail__floatTag = {},   //浮标信息
    _miDetail__dislikeState = 0,
    _miDetail__commentOffsetTop = 0,   // 热门评论到iframe 高度
    _miDetail__tagStartY = 0,
    _miDetail__tagMoveY = 0,
    _miDetail__clientHeight = (document.documentElement || document.body).clientHeight || 570, // 视口高度设置默认值
    _miDetail__clientWidth = (document.documentElement || document.body).clientWidth,
    _miDetail__scrollTop;

const UA = navigator.userAgent || '';

export default function miDetail(isFirst) {
    Utils__checkInitTime(miDetail__init, isFirst);
}

function miDetail__init() {
    var isTagShrink = false;  //记录浮标是否收缩

    // 第三方详情页内容小于等于20个字符时，上报内容为空的自定义事件
    _miDetail__checkEmptyPage();

    // 客户端详情页 native化,不重复渲染
    if (!Utils__isDetailFragmentShow()) {
        return;
    }

    Fragment__insertReadMore();
    Fragment__init();
    _miDetail__onDislikeInit();
    _miDetail__feedbackInit();
    _miDetail__trackExpose();
    _miDetail__pullBottom();
    _miDetail__orientationchange();

    window.addEventListener('message', function (event) {
        var data = event.data,
            order = data.order,
            param = data.param;

        switch (order) {
            case 'registerGlobalFunction':
                _miDetail__initGlobalFunction(param.list);
                break;
            case 'showDislike':
                _miDetail__disReasons = param.reasonsCache; //把理由赋给全局
                _miDetail__insertDislike(param.reasons, param.reasonsCache, param.type);
                _miDetail__initDislikeToast('dislike');
                break;
            case 'hideDislike':
                _miDetail__hideDislike();
                break;
            case 'dislikeMessage':
                _miDetail__showDislikeTip(param.status);
                break;
            case 'showFeedback':
                _miDetail__insertFeedback(param);
                _miDetail__initDislikeToast('feedback');
                break;
            case 'setIframeHeight':
                _miDetail__commentOffsetTop = param.commentTop || 0;
                Common__$('.mi-detail__iframe').height = param.height + 'px';
                break;
            case 'trackExpose':
                window.frames['mi-detail__iframe'].postMessage({order: 'trackExpose', params: [Common__$('.mi-detail__iframe').getBoundingClientRect().top, _miDetail__clientHeight]}, '*');
                break;
            case 'showTextToast':
                _miDetail__showTextToast(param.text);
                break;
            case 'showCommentDelete':
                _miDetail__commentDeleteVisiable(true);
                break;
            case 'hideCommentDelete':
                _miDetail__commentDeleteVisiable(false);
                break;
            case 'miui.getCommentInput':
                if (param.type) {
                    (window.miui || {}).getCommentInput(param.name || '', param.hasCallback || false, param.type);
                } else {
                    (window.miui || {}).getCommentInput(param.name || '', param.hasCallback || false);
                }
                break;
            case 'insertFloatTag':
                _miDetail__floatTag.url = param && param.url;
                _miDetail__floatTag.tagName = param && param.tagName;

                if (Utils__isMiuiBrowser(UA)) {
                    Fragment__insertTag(param);
                }
                break;
            case 'getOuterData':
                _miDetail__transferOuterData();
                break;
            case 'insertBottomTag':
                Fragment__insertBottomTag(param);
                break;
            case 'insertXiangkanBtn':
                Fragment__insertXiangaknBtn(param);
                break;
           case 'readmoreTest':
                console.log('readmoreTest');
                _miDetail__readMore(true);
                break;
            default:
                break;
        }
    });

    window.addEventListener('click', function(e) {
        var $target = e.target,
            hasClass;

        if (!$target) {
          return;
        }

        hasClass = function (className) {
           return Common__domHasClass($target, className);
        };

        switch (true) {
            case hasClass('mi-detail__head-back'):
                // 点击顶bar回退
                _miDetail__back();
                break;
            case hasClass(['mi-detail__read-more-btn', 'mi-detail__read-more-icon']):
                // 阅读更多按钮
                _miDetail__readMore();
                break;
            case hasClass('mi-detail__head-detail'):
                // 顶bar设置icon
                _miDetail__showDetailSettingDialog();
                break;
            case hasClass(['mi-detail__delete', 'mi-detail__second']):
                // 评论删除弹窗取消
                _miDetail__commentDeleteVisiable(false);

                Utils__postMessage({order: 'commentDeleteCancel'});
                break;
            case hasClass('mi-detail__first'):
                // 评论删除弹窗 确认
                _miDetail__commentDeleteVisiable(false);

                Utils__postMessage({order: 'commentDeleteConfirm'});
                break;
            case hasClass(['mi-detail__tag-text', 'mi-detail__tag-container', 'mi-detail__tag-bg', 'mi-detail__tag-icon']):
                // 导流悬浮标，发送到hot-detail中上报点击事件
                Utils__postMessage({ order: 'floatTagClick', param: _miDetail__floatTag});

                if (Utils__isMiuiBrowser(UA)) {
                    window.location.href = _miDetail__floatTag.url;
                }
                break;
            case hasClass('mi-detail__bottom-tag-link'):
                // 搜索词tag
                Utils__postMessage({ order: 'bottomTagClick', param: $target.innerText});
                break;
            case hasClass('mi-detail__read-more-xiangkan-btn'):
                // 点击打开阅读更多
                Utils__postMessage({
                    order: 'xiangkanBtnClick',
                    param: {
                        btn: '打开想看阅读全文',
                        hot: hasClass('mi-detail__read-more_hot-word'),
                    }
                });

                _miDetail__readMore();
                break;
            case hasClass('mi-detail__read-more-xiangkan-icon'):
                // 点击扩展小箭头
                Utils__postMessage({ order: 'xiangkanBtnClick', param: { btn: '扩充箭头' }});

                _miDetail__readMore();
                break;
            case hasClass('image-wrapper'):
                //微博详情页，点击图片跳转
                if (!/cp=cn-weibo/.test(location.search)) return;

                var $img = Common__$('.media-img', $target);

                if ($img.src) {
                    location.href = $img.src;
                }
                break;
            default:
                break;

        }
    });

    //添加滚动事件，控制浮标缩进
    window.addEventListener('scroll', function() {
        var $tag = Common__$('.mi-detail__tag'),
            $tagBg = $tag && Common__$('.mi-detail__tag-bg'),
            $tagContent = $tag && Common__$('.mi-detail__tag-container'),
            direction = '';

        _miDetail__tagMoveY = window.pageYOffset;

        if (_miDetail__tagMoveY > _miDetail__tagStartY) {
            direction = 'up';
        } else if (_miDetail__tagMoveY < _miDetail__tagStartY) {
            direction = 'down';
        }

        _miDetail__tagStartY = _miDetail__tagMoveY;

        if ($tag) {
            if (direction === 'up' && !isTagShrink) {
                Common__domAddClass($tag, 'mi-detail__tag_shrink');

                $tagBg.style.width = '37px';
                isTagShrink = true;
            } else if (direction === 'down' && isTagShrink) {
                Common__domRemoveClass($tag, 'mi-detail__tag_shrink');

                $tagBg.style.width = $tagContent.offsetWidth + 'px';
                isTagShrink = false;
            }
        }
    });

    // 点击评论，滚动
    window.scrollToComment = function() {
        var $header = Common__$('.mi-detail__head'),
            $scroll = document.scrollingElement,
            headerHeight = $header ? $header.offsetHeight : 0,
            top = Common__$('.mi-detail__iframe').offsetTop + _miDetail__commentOffsetTop - headerHeight, // 评论顶部的位置
            maxScroll = document.body.scrollHeight - _miDetail__clientHeight; // 页面能够滚动的最远位置

        Utils__scrollToWithLinear($scroll, Math.min(maxScroll, top));
    };
}

function _miDetail__commentDeleteVisiable(flag) {
    var $delete = Common__$('.mi-detail__delete'),
        $comment = Common__$('.mi-detail__content'),
        fn = flag ? Common__domShow : Common__domHide;

    fn($delete);
    fn($comment);
}

function _miDetail__readMore(silent) {
    const $miDetail = Common__$('#mi-detail');

    if (!Common__$('.mi-detail__read-more')) return;

    Common__domHide(Common__$('.mi-detail__read-more'));
    Common__domRemoveClass($miDetail, 'mi-detail__hide-article');
    $miDetail.style.maxHeight = 'none';

    if (!silent) {
        window.frames['mi-detail__iframe'].postMessage({ order: 'clickReadMore' }, '*');
    }
}

function _miDetail__showDislikeTip(status) {
    var $dislike = Common__$('.mi-detail__dislike-tip');

    Common__domShow($dislike);
    $dislike.innerHTML = status ? '<span>将为你减少类似内容</span>' : '<span>网络不给力，请稍后重试</span>';
}

function _miDetail__showTextToast(text) {
    var $commentToast = Common__$('.mi-detail__text-toast');

    $commentToast.innerHTML = text;
    Common__domShow($commentToast);

    setTimeout(function() {
        Common__domHide($commentToast);
    }, 1000);
}

function _miDetail__insertDislike(reasons, reasonsCache, type) {
    var $dislikeText = Common__$('.mi-detail__dislike-text'),
        $dislikeBd = Common__$('.mi-detail__dislike-bd'),
        $dislikeBtn = Common__$('.mi-detail__dislike-btn'),
        len = reasonsCache.length,
        text,
        btnText,
        item,
        str = '<div>';

        $dislikeBtn.dataset.type = type == 'comment' ? 'comment' : '';

        if (len > 0) {
            btnText = '确定';
            text = '已选<span>' + len + '</span>理由';
        } else {
            if (type == 'comment') {
                btnText = '举报';
                text = '选择举报理由';
            } else {
                btnText = '不感兴趣';
                text = '可选理由，精准屏蔽';
            }
        }

        for (var i = 0; i < reasons.length ; i++) {
            if (reasons[i] && reasons.length <= 6) {
                item = reasons[i];
                str += '<div class="mi-detail__dislike-reason ' +
                        (reasonsCache.indexOf(item) != -1 ? ' mi-detail__dislike-reason_on' : '') +
                        '">' + item + '</div>';
            }
        }

        str += '</div>';

    $dislikeBtn.textContent = btnText;
    $dislikeText.innerHTML = text;
    $dislikeBd.innerHTML = str;
}

function _miDetail__hideDislike() {
    const $dislikeWrap = Common__$('.mi-detail__dislike');

    if ($dislikeWrap.style.visibility === 'visible') {
        _miDetail__dislikeState = 0;
        Common__domTrigger($dislikeWrap, 'click');
    }
}

function _miDetail__initGlobalFunction(list) {
    (list || []).forEach(function(name) {
        window[name] = function() {
            window.frames['mi-detail__iframe'].postMessage({order: 'miGlobalCallback',
                param: {
                    type: name,
                    arguments: [...arguments],
            }}, '*');
        };
    });
}

function _miDetail__orientationchange() {
    var timer,
        delay = 300,
        $dislike = Common__$('.mi-detail__dislike-content');

    Common__domOn(window, 'orientationchange', function() {
        clearTimeout(timer);

        timer = setTimeout(function() {
            if ($dislike && $dislike.style.visibility == 'visible') {
                $dislike.style.top = (_miDetail__clientHeight - $dislike.clientHeight) / 2 + 'px';
            }
        }, delay);
    });
}

function _miDetail__back() {
    try {
        window.miui.onBackKey();
    } catch(e) {
        history.back();
    }
}

function _miDetail__showDetailSettingDialog() {
    try {
        window.miui.showDetailSettingDialog();
    } catch(e) {}
}

function _miDetail__touchmovePrevent(e) {
    e.preventDefault();
}

function _miDetail__onDislikeInit() {
    var $dislikeWrap = Common__$('.mi-detail__dislike'),
        $dislike = Common__$('.mi-detail__dislike-content'),
        $dislikeBtn = Common__$('.mi-detail__dislike-btn', $dislike),
        $dislikeText = Common__$('.mi-detail__dislike-text', $dislike),
        $dislikeTip = Common__$('.mi-detail__dislike-tip'),
        $dislikeBd = Common__$('.mi-detail__dislike-bd'),
        dislikeReasonCLASS = 'mi-detail__dislike-reason_on',
        data = {},
        $dislikeReason;

      //阻止背景滚动
    Common__domOn($dislikeWrap, 'touchmove', _miDetail__touchmovePrevent);
    Common__domOn($dislike, 'touchmove', _miDetail__touchmovePrevent);

    Common__domOn($dislikeWrap, 'click', function() { //点击背景色取消
        if ((Date.now() - 400) > _miDetail__disStartTime) {
            window.frames['mi-detail__iframe'].postMessage({order: 'clickDislikeWrap'}, '*');

            $dislikeWrap.style.visibility = 'hidden';
            $dislike.style.visibility = 'hidden';
            $dislikeBd.innerHTML = '';

            _miDetail__clearDislikeHistory();
        }
    });

    Common__domOn($dislike, 'click', function(e){
        var ret = _miDetail__disReasons,
            reasonCount = ret.length,
            $target = e.target;

        $dislikeReason = Common__domClosest($target, '.mi-detail__dislike-reason', $dislike);

        if ($dislikeReason) {
            if(!Common__domHasClass($dislikeReason, dislikeReasonCLASS)) {
                reasonCount++;
                ret.push($dislikeReason.textContent);

                Common__domAddClass($dislikeReason, dislikeReasonCLASS);
            } else {
                reasonCount--;
                Common__arrayRemove(ret, $dislikeReason.textContent);

                Common__domRemoveClass($dislikeReason, dislikeReasonCLASS);
            }
        } else if (Common__domClosest($target, '.mi-detail__dislike-btn', $dislike)) { //提交不喜欢原因
            setTimeout(function() {
                $dislikeWrap.style.visibility = 'hidden';
                $dislike.style.visibility = 'hidden';
                $dislikeBd.innerHTML = '';
                _miDetail__clearDislikeHistory();
            }, 0);

            data.reasons = ret;

            window.frames['mi-detail__iframe'].postMessage({order: 'clickDislikeBtn', param: {
                reasons: ret
            }}, '*');
        }

        if (reasonCount > 0) {
            $dislikeBtn.textContent = $dislikeBtn.dataset.type == 'comment' ? '确定举报' : '确定';
            $dislikeText.innerHTML = '已选' + '<span>' + reasonCount + '</span>' + '理由';
        } else {
            if ($dislikeBtn.dataset.type == 'comment') {
                $dislikeBtn.textContent = '举报';
                $dislikeText.textContent = '选择举报理由';
            } else {
                $dislikeBtn.textContent = '不感兴趣';
                $dislikeText.textContent = '可选理由，精准屏蔽';
            }
        }

        e.stopPropagation(); //阻止冒泡, 否则会触发条目点击
    }, true);

    Common__domOn($dislikeTip, 'webkitAnimationEnd', function () {
        if ($dislikeTip.style.opacity == 0) {
            Common__domHide($dislikeTip);
        }
    });

    Common__domOn(window, 'popstate', function() {
        //这里修改状态是区分history触发的$dislikeWrap点击还是手动点击
        if ($dislikeWrap.style.visibility === 'visible') {
            _miDetail__dislikeState = 0;
            Common__domTrigger($dislikeWrap, 'click');
        }
    });
}

//清除dislike的历史记录
function _miDetail__clearDislikeHistory() {
    history.replaceState(null, null);

    if (_miDetail__dislikeState) {
        _miDetail__dislikeState = 0;
        history.back();
    }
}

function _miDetail__initDislikeToast(type) {
    var wrapCLASS = 'mi-detail__' + type,
        contentCLASS = 'mi-detail__' + type + '-content',
        bgCLASS = 'mi-detail__' + type + '-bg',
        $dislikeWrap = Common__$('.' + wrapCLASS),
        $dislikeContent = Common__$('.' + contentCLASS),
        $dislikeBg = Common__$('.' + bgCLASS);

    $dislikeContent.style.top = (_miDetail__clientHeight - $dislikeContent.clientHeight) / 2 + 'px';

    _miDetail__dislikeState = 1;
    $dislikeWrap.style.visibility = 'visible';
    $dislikeContent.style.visibility = 'visible';

    if (type == 'feedback') {
        $dislikeBg.style.visibility = 'visible';
    }

    _miDetail__disStartTime = Date.now();

    history.pushState({dislike: 1}, 'dislike');
}

function _miDetail__trackExpose() {
    var timer,
        param = {
            viewportHeight: _miDetail__clientHeight,
            readMoreFlag: false,
        },
        delay = 1000;

    window.addEventListener('scroll', Common__debounce(function() {
        timer = setTimeout(function() {
            var $readMoreBtn = Common__$('.mi-detail__read-more-btn'),
                $tag = Common__$('.mi-detail__bottom-tag'),
                $readMoreXk = Common__$('.mi-detail__read-more-xiangkan'),
                rect,
                distance;

            if ($readMoreBtn) {
                rect = $readMoreBtn.getBoundingClientRect();
                distance = rect.top + rect.height;
            }

            if ($readMoreBtn && distance > 0 && distance < param.viewportHeight) {
                param.readMoreFlag = true;
            }

            if ($readMoreXk) {
                rect = $readMoreXk.getBoundingClientRect();
                distance = rect.top + rect.height;

                if (distance > 0 && distance < param.viewportHeight) {
                    param.readMoreXkFlag = true;
                }
            }

            param.iframeTop = Common__$('.mi-detail__iframe').getBoundingClientRect().top;

            window.frames['mi-detail__iframe'].postMessage({order: 'trackExpose', param: param}, '*');

            // 标签曝光打点
            if ($tag) {
                _miDetail__bottomTagExpose();
            }
        }, delay);
    }, 250), true);

    window.addEventListener('scroll', function() {
        clearTimeout(timer);
    }, true);
}

function _miDetail__pullBottom() {
    var delay = 250,
        $iframe,
        iframeTop;

    window.addEventListener('scroll', Common__throttle(function() {
        $iframe = Common__$('.mi-detail__iframe');
        iframeTop = $iframe ? $iframe.getBoundingClientRect().top : 0;

        window.frames['mi-detail__iframe'].postMessage({order: 'scrollComment', param: {
            clientHeight: _miDetail__clientHeight,
            clientWidth: _miDetail__clientWidth,
            iframeTop: iframeTop,
        }}, '*');
    }, delay));
}

function _miDetail__insertFeedback(param) {
    var $feedback = Common__$('.mi-detail__feedback-content');

    _miDetail__feedBack = param.reasons;
    $feedback.innerHTML = tpl__feedbackContent(param);
    _miDetail__feedbackContentInit($feedback);
}

function _miDetail__feedbackInit() {
    var $feedback = Common__$('.mi-detail__feedback-content'),
        $container = Common__$('.mi-detail__feedback-container'),
        $feedbackWrap = Common__$('.mi-detail__feedback', $container),
        $feedbackBg = Common__$('.mi-detail__feedback-bg', $container),
        $dislikeTip = Common__$('.mi-detail__dislike-tip');

    // 触碰背景色取消
    Common__domOn($feedbackWrap, 'touchstart', function() {
        if ((Date.now() - 400) > _miDetail__disStartTime) {
            window.frames['mi-detail__iframe'].postMessage({order: 'clickDislikeWrap'}, '*');

            $feedbackWrap.style.visibility = 'hidden';
            $feedback.style.visibility = 'hidden';
            $feedback.style.height = '';

            _miDetail__clearDislikeHistory();

            // 恢复页面滑动
            setTimeout(function (){
                _miDetail__pageFixed(false);
                // 蒙层，防止点击穿透
                $feedbackBg.style.visibility = 'hidden';
            }, 300);
        }
    });

    // 点击负反馈任意原因，即提交。
    Common__domOn($feedback, 'click', function(e){
        var $target = Common__domClosest(e.target, 'a'),
            $text,
            type,
            reason;

        if(!$target) {
            return;
        }

        // 提交负反馈，移除负反馈交互界面
        setTimeout(function() {
            $feedbackWrap.style.visibility = 'hidden';
            $feedback.style.visibility = 'hidden';
            $feedback.style.height = '';

            _miDetail__clearDislikeHistory();

            // 恢复页面滑动
            setTimeout(function (){
                _miDetail__pageFixed(false);
                $feedbackBg.style.visibility = 'hidden';
            }, 300);
        }, 0);

        // 负反馈原因提交打点
        if (Common__domHasClass($target, 'mi-detail__feedback-ad')) {
            $text = Common__$('.mi-detail__feedback-text', $target);
            reason = $text.innerText;
        } else {
            if (Common__domHasClass($target, 'mi-detail__feedback-categories')) {
                var subCategory = _miDetail__feedBack.sub_categories && _miDetail__feedBack.sub_categories[0];
                type = subCategory ? 'subCategories' : 'categories';
                reason = subCategory || _miDetail__feedBack.categories[0];
            } else if (Common__domHasClass($target, 'mi-detail__feedback-source')) {
                type = 'source';
                reason = _miDetail__feedBack.source;
            } else if (Common__domHasClass($target, 'mi-detail__feedback-btn_item_quality')) {
                type = 'quality';
                reason = $target.innerText;
            } else if (Common__domHasClass($target, 'mi-detail__feedback-btn_keywords')) {
                type = 'keywords';
                reason = $target.innerText.slice(3);
            }
        }

        window.frames['mi-detail__iframe'].postMessage({order: 'clickDislikeBtn', param: {
            reasons: reason,
            type: type,
        }}, '*');

        e.stopPropagation(); //阻止冒泡, 否则会触发条目点击
    }, true);

    Common__domOn($dislikeTip, 'webkitAnimationEnd', function() {
        Common__domHide($dislikeTip);
    });

    Common__domOn(window, 'popstate', function() {
        //这里修改状态是区分history触发的$dislikeWrap点击还是手动点击
        if ($feedbackWrap.style.visibility === 'visible') {
            _miDetail__dislikeState = 0;
            Common__domTrigger($feedbackWrap, 'touchstart');
        }
    });
}

function _miDetail__feedbackContentInit($feedback) {
    var $first = Common__$('.mi-detail__feedback-first', $feedback),
        $quality = Common__$('.mi-detail__feedback-quality', $feedback),
        $qualityDiv = Common__$('.mi-detail__feedback-second_item_quality', $feedback),
        $keywords = Common__$('.mi-detail__feedback-keywords', $feedback),
        $keywordsDiv = Common__$('.mi-detail__feedback-second_keywords', $feedback),
        height = $first.offsetHeight;

    // 禁止页面滑动
    _miDetail__pageFixed(true);

    // 初始化宽高
    $feedback.style.height = height + 'px';
    $feedback.style.willChange = 'height';

    if ($quality) {
        _miDetail__feedbackSwipeInit($quality, $qualityDiv);
    }

    if ($keywords) {
        _miDetail__feedbackSwipeInit($keywords, $keywordsDiv);
    }
}

function _miDetail__feedbackSwipeInit($tab, $second) {
    var $swipe = Common__domClosest($tab, '.mi-detail__feedback-swipe'),
        $first = Common__domClosest($tab, '.mi-detail__feedback-first'),
        $return = Common__$('.mi-detail__feedback-tab-return', $second),
        width = $first.offsetWidth,
        height = $first.offsetHeight,
        secondHeight = $second.offsetHeight;

    Common__domOn($tab, 'click', function(){
        $swipe.style.height = secondHeight + 'px';
        calcTransform($first.style, -width);
        calcTransform($second.style, 0);
    });

    Common__domOn($return, 'click', function(){
        $swipe.style.height = height + 'px';
        calcTransform($first.style, 0);
        calcTransform($second.style, width);
    });

    function calcTransform (style, num) {
        var transform = 'translate3d(' + num + 'px, 0, 0)';

        style.transform = transform;
        style.webkitTransform = transform;
    }
}

// 禁止蒙层底部页面滑动
function _miDetail__pageFixed(isFixed) {
    var $scroll = document.scrollingElement;

    if (!$scroll) {
        return;
    }

    if (isFixed) {
        _miDetail__scrollTop = $scroll.scrollTop;
        $scroll.style.position = 'fixed';
        $scroll.style.top = -_miDetail__scrollTop + 'px';
        $scroll.style.width = '100%';
    } else {
        $scroll.style.position = '';
        $scroll.style.top = '';
        $scroll.style.width = '';
        $scroll.scrollTop = _miDetail__scrollTop;
    }
}

// 第三方详情页内容小于等于20个字符时，上报内容为空的自定义事件
function _miDetail__checkEmptyPage() {
    var state = Utils__parseQuery(Utils__getQueryString()),
        $miDetail = Common__$('#mi-detail'),
        innerText = $miDetail.innerText;

    if (innerText.length <= 20) {
        stats__send({
            name: '文章详情页',
            cate: '内容为空',
            action: '曝光',
            path: Utils__getBrowserCategory(state.cateCode),
            ext: JSON.stringify({
                url: location.href,
                cp: state.cp,
                content: innerText
            })
        });

        // 通知客户端 内容加载失败
        Utils__notifyClientArticleNotFound();
    }
}

// 给第三方详情页组件传递一些网页的参数
function _miDetail__transferOuterData() {
    window.frames['mi-detail__iframe'].postMessage({
        order: 'transferOuterData',
        param: {
            href: location.href,
        }
    }, '*');
}

function _miDetail__bottomTagExpose() {
    var $$track = Common__$$('.mi-detail__track'),
        $container = Common__$('.mi-detail__bottom-tag-container'),
        length = $$track.length,
        outer = $container.getBoundingClientRect(),
        i;

    for (i = 0; i < length; i++) {
        pushExposeData($$track[i]);
    }

    function pushExposeData ($item) {
        var rect = $$track[i].getBoundingClientRect(),
            noNeedExpose = $item.dataset.viewTime,
            isHidden = rect.top >= outer.bottom, // tag超出两行被隐藏--overflow:hidden
            distance = rect.top + rect.height;

        // 标签未曝光过，且未隐藏，出现在视窗内进行一次曝光
        if (!noNeedExpose && !isHidden && distance > 0 && distance < _miDetail__clientHeight) {
            $item.dataset.viewTime = Date.now();
            window.frames['mi-detail__iframe'].postMessage({order: 'bottomTagExpose', param: {
                tag: $item.innerText,
                index: $item.dataset.index,
            }}, '*');
        }
    }
}

export function miDetail__shareTrackExpose(UA) {
    var state = Utils__parseQuery(Utils__getQueryString()),
        channel = Utils__getShareChannel(UA);

    if (channel) {
        stats__send({
            appId: browserShareAppId,
            token: browserShareToken,
            name: '图文详情页',
            cate: '端外分享',
            action: '曝光',
            path: '端外分享页',
            ext: JSON.stringify({
                cp: state.cp,
                share_channel: channel,
                docid: state.docid,
            })
        });
    }
}
